import gsap from "gsap";

document.addEventListener('DOMContentLoaded', () => {
  const callback = document.querySelector('.callback')
  const callbackForm = document.querySelector('.callback-form')

  if (callbackForm && callback)  {
    const callbackBacks = document.querySelectorAll('.callback__back')
    const callbackNav = callbackForm?.querySelector('.callback-form__nav')
    const callbackNavs = callbackForm?.querySelectorAll('.callback-form__nav-item')
    const callbackSteps = callbackForm?.querySelectorAll('.callback-form__step')
    const callbackStep2Items = Object.values(callbackForm?.querySelectorAll('[data-mark-list]'))
    const callbackCurrentStep = callbackForm?.querySelector('.callback-form__current-step')
    const callbackButtonsPrev = callbackForm?.querySelectorAll('.callback-form__button-prev')
    const callbackButtonsNext = callbackForm?.querySelectorAll('.callback-form__button-next')

    const callbackImage = callbackForm?.querySelector('.callback-image')
    const callbackChoice = callbackImage?.querySelector('.callback-image__choice')
    const callbackEmpty = callbackImage?.querySelector('.callback-image__empty')
    const callbackFull = callbackImage?.querySelector('.callback-image__full')
    const callbackDeleteImage = callbackImage?.querySelector('.callback-image__delete-image')

    const prevDef = e => e.preventDefault()

    window.addEventListener('dragover', prevDef)
    window.addEventListener('drop', prevDef)

    const formData = {
      mark: null,
      model: null,
      img: null,
      name: null,
      contact: null
    }

    callbackForm.addEventListener('submit', (e) => {
      e.preventDefault();
      console.log(2);
    })

    const timeline = gsap.timeline()
    const delay = 0
    const duration = 0.5
    let currentStep = 1
    let listOpen = null
    let animations = false
    const openStep = async (step = null) => {
      if(animations) return
      animations = true
      callbackNavs[currentStep - 1].classList.remove('callback-form__nav-item--active')
      timeline.to(callbackSteps[currentStep - 1], { opacity: 0, delay, duration })
      timeline.to(callbackSteps[currentStep - 1], { display: 'none', delay, duration: 0 })
      step ? currentStep = step : currentStep++
      timeline.to(callbackSteps[currentStep - 1], { display: 'grid', delay, duration: 0, opacity: 0 }, '>')
      timeline.to(callbackSteps[currentStep - 1], { duration, opacity: 1, delay })

      if (currentStep === 2) {
        if (listOpen) timeline.to(listOpen, { display: 'none', delay, duration: 0 }, "<")
        const step2 = callbackStep2Items.find(step => step.getAttribute(['data-mark-list']).trim() === formData.mark)
        step2.classList.add('callback-form__list--open')
        listOpen = step2
        timeline.to(step2, { display: 'grid', delay, duration: 0 }, '<')
        timeline.to(step2, { duration, opacity: 1, delay })
      }
      const callbackActions = callbackSteps[currentStep - 1].querySelector('.callback-form__actions')


      if (currentStep > 1 && callbackActions) {
        timeline.fromTo(callbackActions, { opacity: 0, display: 'flex' }, { opacity: 1, duration, delay }, "< ")
      }
      if(currentStep % 2) {
        timeline.to(callbackBacks[0], {
          opacity: 1,
          duration,
          delay
        }, '>')
        timeline.to(callbackBacks[1], {
          opacity: 0,
          duration,
          delay
        }, '<')
      } else {
        timeline.to(callbackBacks[1], {
          opacity: 1,
          duration,
          delay
        }, '>')
        timeline.to(callbackBacks[0], {
          opacity: 0,
          duration,
          delay
        }, '<')
      }

      if (callbackCurrentStep) {
        callbackCurrentStep.innerHTML = currentStep === 4 ? 'DONE' : currentStep + '/3'
      }
      if(currentStep === 4) {
        callbackCurrentStep.classList.add('callback-form__current-step--finally')
        timeline.to(callbackNav, {opacity: 1, delay, duration}, '<')
        timeline.to(callbackNav, {display: 'none', delay, duration: 0}, '<')
      } else {
        callbackNavs[currentStep - 1].classList.add('callback-form__nav-item--active')
      }

      if(window.innerWidth < 780) {
        window.scrollTo({top: callback.offsetTop + callbackForm.offsetTop, behavior: 'smooth'})
      }

      setTimeout(()=> {
        if(currentStep === 3) {
          window.resize()
        }
        animations = false
      }, timeline.totalDuration() + 1000)
    }

    callbackButtonsPrev.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        openStep(currentStep - 1)
      })
    })

    callbackButtonsNext.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        openStep(currentStep + 1)
      })
    })

    if (callbackSteps) {
      const callbackStep1Buttons = callbackSteps[0].querySelectorAll('.callback-button')
      callbackStep1Buttons?.forEach(button => {
        button.addEventListener('click', () => {
          formData.mark = button.getAttribute('data-mark').trim()
          openStep()
        })
      })

      const callbackStep2Buttons = callbackSteps[1].querySelectorAll('.callback-button')
      callbackStep2Buttons.forEach(button => {
        button.addEventListener('click', () => {
          formData.model = button.getAttribute('data-mark').trim()
          openStep()
        })
      })
    }

    if (callbackImage && callbackEmpty && callbackFull && callbackChoice) {
      const callbackInput = callbackImage.querySelector('.callback-image__input')
      const callbackFullImage = callbackFull.querySelector('img')
      const nextButtonText = callbackImage.querySelector('.callback-form__button-next span')
      let timeline = gsap.timeline()

      const closeEmpty = () => {
        if (nextButtonText) nextButtonText.innerHTML = 'next'
        callbackFullImage.src = URL.createObjectURL(formData.img)
        timeline.to(callbackEmpty, { opacity: 1, delay, duration })
        timeline.to(callbackEmpty, { display: 'none', delay, duration: 0 })
        timeline.to(callbackFull, { display: 'flex', opacity: 0, delay, duration: 0 }, '<')
        timeline.to(callbackFull, { opacity: 1, delay, duration })

      }

      const closeFull = () => {
        if (nextButtonText) nextButtonText.innerHTML = 'skip'
        timeline.to(callbackFull, { opacity: 0, delay, duration })
        timeline.to(callbackFull, { display: 'none', delay, duration: 0 })
        timeline.to(callbackEmpty, { display: 'grid', opacity: 0, delay, duration: 0 }, '<')
        timeline.to(callbackEmpty, { opacity: 1, delay, duration })
        callbackFullImage.src = ''
      }
      let dragOver = false
      const borders = callbackEmpty.querySelectorAll('.callback-image__empty span')
      const selectFile = (file) => {
        formData.img = file
        const dataTransfer = new DataTransfer()
        dataTransfer.items.add(file)
        callbackInput.files = dataTransfer.files
        closeEmpty()
      }

      callbackEmpty.addEventListener('drop', (e) => {
        let file = Object.values(e.dataTransfer.files).find(file => file.type.indexOf('image') === 0)
        selectFile(file)
      })
      callbackChoice.addEventListener('dragover', (e) => {
        const callbackChoiceHeight = callbackChoice.clientHeight / 2
        const callbackChoiceWidth = callbackChoice.clientWidth / 2
        e.preventDefault()
        e.stopPropagation()
        if (!formData.img && !dragOver) {
          borders.forEach(border => {
            gsap.to(border, {
              width: callbackChoiceWidth,
              height: callbackChoiceHeight,
              duration: 0.2,
              delay,
              ease: "elastic"
            })
          })
          dragOver = true
        }
      })
      callbackChoice.addEventListener('dragleave', (e) => {
        if (callbackEmpty.contains(e.target) || callbackEmpty === e.target) return
        if (!formData.img && dragOver) {
          borders.forEach(border => {
            gsap.to(border, { width: '164px', height: '113px', duration: 0.2, delay, ease: "elastic" })
          })
          dragOver = false
        }
      })

      callbackDeleteImage?.addEventListener('click', () => {
        closeFull()
        formData.img = null
        borders.forEach(border => {
          gsap.to(border, { width: '164px', height: '113px', duration: 0, delay })
        })
      })

      callbackInput?.addEventListener('change', () => selectFile(callbackInput.files[0]))
    }

    const callBacKContact = callbackForm.querySelector('.callback-contact__input--contact input')
    const callBacKContactError = callbackForm.querySelector('.callback-contact__input--contact .input-wrapper__error')
    const callBacKName = callbackForm.querySelector('.callback-contact__input--name input')
    const callBacKNameError = callbackForm.querySelector('.callback-contact__input--name .input-wrapper__error')
    const callBackButton = callbackForm.querySelector('.callback-contact__button')
    const callBackPrivacy = callbackForm.querySelector('.callback-contact__checkbox'
    )
    const checkInputs = {
      name: null,
      contact: null
    }
    const buttonDisabled = (disabled = true) => {
      disabled ? callBackButton.setAttribute('disabled', true) : callBackButton.removeAttribute('disabled')
    }

    const checkData = (clickButton = false) => {
      if (clickButton) {
        checkInputs.name = true
        checkInputs.contact = true
      }
      let disabled = false
      if (checkInputs.contact && !callBacKContact.value) {
        callBacKContactError.classList.add('input-wrapper__error--view')
        disabled = true
      } else callBacKContactError.classList.remove('input-wrapper__error--view')

      if (checkInputs.name && !callBacKName.value) {
        callBacKNameError.classList.add('input-wrapper__error--view')
        disabled = true
      } else callBacKNameError.classList.remove('input-wrapper__error--view')

      if(!callBackPrivacy.checked) disabled = true

      buttonDisabled(disabled)
      return disabled
    }
    callBackPrivacy?.addEventListener('change', () => checkData() )


    callBacKContact.addEventListener('blur', () => {
      checkInputs.contact = true
      checkData()
    })
    callBacKName.addEventListener('blur', () => {
      checkInputs.name = true
      checkData()
    })


    callBacKContact.addEventListener('input', () => {
      callBacKContact.value = callBacKContact.value.trim()
      formData.contact = callBacKContact.value
      checkData()
    })

    callBacKName.addEventListener('input', () => {
      callBacKName.value = callBacKName.value.trim()
      formData.name = callBacKName.value
      checkData()
    })

    callBackButton?.addEventListener('click', (e) => {
      let disabled = checkData(true)

      if (!disabled) {
        openStep();
      } else {
        e.preventDefault();
      }
    })
  }
})